"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBrandFullName = exports.brandParameter = exports.isFeatureEnabled = exports.getCookiesSettings = exports.getLanguage = exports.getSettingsState = void 0;
function getSettingsState(states) {
    return states === null || states === void 0 ? void 0 : states.settings;
}
exports.getSettingsState = getSettingsState;
function getLanguage(states) {
    var _a;
    return (_a = states === null || states === void 0 ? void 0 : states.settings) === null || _a === void 0 ? void 0 : _a.language;
}
exports.getLanguage = getLanguage;
function getCookiesSettings(states) {
    var _a;
    return (_a = states === null || states === void 0 ? void 0 : states.settings) === null || _a === void 0 ? void 0 : _a.cookies;
}
exports.getCookiesSettings = getCookiesSettings;
/**
 * isFeatureEnabled returns the state of a feature if it's enabled or not
 * selection order
 * 1- userBrandParameters (connected user brandparameters)
 * 2- params (not connect user brandparameters example of usage login )
 * 3- default is false
 * @param {state} states the current state of the widget or website
 * @param {string} feature the feature to test if enabled or not
 * @returns {boolean} the state of that feature
 */
function isFeatureEnabled(states, feature) {
    var _a, _b, _c, _d;
    var enabled = false;
    var userFeatures = (_b = (_a = states === null || states === void 0 ? void 0 : states.settings) === null || _a === void 0 ? void 0 : _a.userBrandParameters) === null || _b === void 0 ? void 0 : _b.Features;
    var defaultFeatures = (_d = (_c = states === null || states === void 0 ? void 0 : states.settings) === null || _c === void 0 ? void 0 : _c.params) === null || _d === void 0 ? void 0 : _d.Features;
    if (userFeatures && userFeatures[feature] != null && userFeatures[feature] != undefined)
        enabled = userFeatures[feature];
    else if (defaultFeatures && defaultFeatures[feature] != null && defaultFeatures[feature] != undefined)
        enabled = defaultFeatures[feature];
    return enabled;
}
exports.isFeatureEnabled = isFeatureEnabled;
/**
 * brandParameter return the value of a brandParameter
 * it verifies either userBranParameter or params and return the value of that parameter
 * its default value is null
 * @param {state} states the current state of the widget or website
 * @param {string} brandParameter the brand parameter to get its value
 * @returns {any} return the value of the brandParameter
 */
function brandParameter(states, brandParameter) {
    var _a, _b;
    var value = null;
    var userBrandParameter = (_a = states === null || states === void 0 ? void 0 : states.settings) === null || _a === void 0 ? void 0 : _a.userBrandParameters;
    var defaultBrandParameter = (_b = states === null || states === void 0 ? void 0 : states.settings) === null || _b === void 0 ? void 0 : _b.params;
    if (userBrandParameter && userBrandParameter[brandParameter] != undefined)
        value = userBrandParameter[brandParameter];
    if (defaultBrandParameter && defaultBrandParameter[brandParameter] != undefined)
        value = defaultBrandParameter[brandParameter];
    return value;
}
exports.brandParameter = brandParameter;
/**
 * Retrieve the brand fullname from the state
 * @param states the current state of the widget or website
 * @returns The brand parameter fullname
 */
function getBrandFullName(states) {
    return brandParameter(states, 'BrandFullName');
}
exports.getBrandFullName = getBrandFullName;
